
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/ai/onboarding",
      function () {
        return require("private-next-pages/candidate/ai/onboarding/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/ai/onboarding"])
      });
    }
  